'use client';

import { useEffect } from 'react';
import {
  alloyBootstrapScript,
  alloyConfigurationScript,
  alloyPrehidingScript,
} from '~/scripts/adobe-script';

type Props = {
  datastreamId: string;
};

export function AlloyScriptInjector({ datastreamId }: Props) {
  useEffect(() => {
    const prehiding = document.createElement('script');
    prehiding.innerHTML = alloyPrehidingScript;
    document.head.appendChild(prehiding);

    const bootstrap = document.createElement('script');
    bootstrap.innerHTML = alloyBootstrapScript;
    document.head.appendChild(bootstrap);

    const alloyLib = document.createElement('script');
    alloyLib.src = 'https://cdn1.adoberesources.net/alloy/2.24.0/alloy.min.js';
    alloyLib.async = true;

    alloyLib.onload = () => {
      const configScript = document.createElement('script');
      configScript.innerHTML = alloyConfigurationScript(datastreamId);
      document.head.appendChild(configScript);
    };

    document.head.appendChild(alloyLib);
  }, [datastreamId]);

  return null;
}
